import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./Establish.scss";
class Establish extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <div className="container about-content">
        <div className="row">
          <div className="col-lg-12" style={{ padding: "8vh" }}>
            <h2>Giới thiệu về Anovator</h2>
            <p>
              <strong>Anovator</strong> được thành lập vào tháng 11 năm 2013, là
              đơn vị tiên phong trong lĩnh vực{" "}
              <strong>đo lường dữ liệu cơ thể người</strong> dựa trên nền tảng{" "}
              <strong>công nghệ đổi mới sáng tạo.</strong> Chúng tôi cam kết
              mang đến giải pháp
              <strong>
                {" "}
                đo đạc sức khỏe chính xác, khoa học, toàn diện và tiện lợi
              </strong>{" "}
              cho người dùng trong ngành{" "}
              <strong>y tế và chăm sóc sức khỏe toàn cầu.</strong>
            </p>
            <p>
              Ứng dụng công nghệ <strong>AI</strong> và <strong>IoT</strong>,
              thiết bị của Anovator có khả năng phân tích đa dạng các chỉ số sức
              khỏe cho mọi lứa tuổi, như:
            </p>
            <ul>
              <li>
                <strong>Thành phần cơ thể, huyết áp, oxy máu, nhịp tim</strong>
              </li>
              <li>
                <strong>
                  Dung tích phổi, khả năng giữ thăng bằng, phản xạ, thị lực
                </strong>
              </li>
              <li>
                <strong>Tư thế cơ thể, rủi ro sức khỏe, v.v.</strong>
              </li>
            </ul>
            <p>
              Thiết bị tự động thu thập dữ liệu, xuất báo cáo phân tích sức khỏe
              đáng tin cậy và hỗ trợ <strong>API tích hợp</strong> cho các hệ
              thống quản lý chuyên sâu.
            </p>
            <h3>Ứng dụng toàn cầu – Công nghệ vì sức khỏe</h3>
            <p>
              Sản phẩm của Anovator hiện đang được ứng dụng rộng rãi trong các
              lĩnh vực{" "}
              <strong>
                thể hình, chăm sóc sức khỏe, phục hồi chức năng và giáo dục thể
                chất.
              </strong>{" "}
              Chúng tôi đã cung cấp giải pháp cho hàng trăm{" "}
              <strong>
                phòng gym, trung tâm thể thao, phòng khám và bệnh viện
              </strong>
              tại hơn <strong>10 quốc gia,</strong> bao gồm{" "}
              <strong>Mỹ, Canada, Tây Ban Nha, Singapore…</strong> Những phản
              hồi tích cực từ người dùng đã tiếp thêm động lực để chúng tôi
              không ngừng cải tiến và hoàn thiện sản phẩm.
            </p>
            <h3>Tại Việt Nam - Đồng hành cùng GYM HẢI PHƯỚC</h3>
            <p>
              Tại Việt Nam, <strong>CÔNG TY TNHH GYM HẢI PHƯỚC</strong> là{" "}
              <strong>đối tác phân phối độc quyền </strong>của Anovator. Với
              năng lực triển khai mạnh mẽ, đội ngũ chuyên nghiệp và sự đồng hành
              sát sao cùng khách hàng, GYM HẢI PHƯỚC đã góp phần đưa giải pháp{" "}
              <strong>đo lường dữ liệu cơ thể thông minh</strong> vào thực tiễn
              tại nhiều{" "}
              <strong>
                trung tâm thể hình, trường học, phòng khám và bệnh viện trên
                toàn quốc.
              </strong>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Establish)
);
